"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWarnTabClose = void 0;
const react_1 = require("react");
const useWarnTabClose = () => {
    (0, react_1.useEffect)(() => {
        const handleUnload = (e) => {
            e.preventDefault();
            e.returnValue = '';
        };
        window.addEventListener('beforeunload', handleUnload);
        return () => {
            window.removeEventListener('beforeunload', handleUnload);
        };
    }, []);
};
exports.useWarnTabClose = useWarnTabClose;
//# sourceMappingURL=index.js.map